import { get, post } from '../../../../api/axios';
import { ManagerManagementEndpoints } from '../../../../api/endpoints/ManagerManagementEndpoints';
import { type ContactDto } from '../../../models/Contact';
import { type InstallmentDto } from '../../../models/InstallmentDto';
import { type PointOfSaleDto } from '../../../models/PointOfSale';
import {
  type ManagerDashboardChartDto,
  type ManagerDashboardFilterRequestDto,
  type ManagerDashboardMetricsDto,
} from './_models';

export const getManagerCommunities = () => {
  return get<ContactDto[]>(ManagerManagementEndpoints.listCommunities);
};

export const getManagerPointsOfSale = (communityId: string) => {
  return get<PointOfSaleDto[]>(`${ManagerManagementEndpoints.listPointsOfSale}?community_id=${communityId}`);
};

export const getManagerDashboardMetrics = (payload: ManagerDashboardFilterRequestDto) => {
  return post<ManagerDashboardMetricsDto>(ManagerManagementEndpoints.dashboardMetrics, payload);
};

export const getManagerDashboardChart = (payload: ManagerDashboardFilterRequestDto) => {
  return post<ManagerDashboardChartDto>(ManagerManagementEndpoints.dashboardChart, payload);
};

export const uploadPaymentDocument = (installmentId: string, payload: FormData) => {
  return post<void>(ManagerManagementEndpoints.uploadPaymentDoc(installmentId), payload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getManagerInstallmentDetails = (installmentId: string) => {
  return get<InstallmentDto>(ManagerManagementEndpoints.installmentDetails(installmentId));
};
